import { Theme } from '@mui/material/styles';

/** Adobe blue — navbar / login logo channel icons in light mode. */
export const LIGHT_LOGO_ICON_COLOR = '#1473e6';

const DARK_CHANNEL_ICON_COLORS = {
    message: '#22c55e',
    mail: '#3b82f6',
    send: '#06b6d4',
} as const;

export const getSiteLogoChannelIconColors = (theme: Theme) => {
    if (theme.palette.mode === 'light') {
        return {
            message: LIGHT_LOGO_ICON_COLOR,
            mail: LIGHT_LOGO_ICON_COLOR,
            send: LIGHT_LOGO_ICON_COLOR,
        };
    }
    return { ...DARK_CHANNEL_ICON_COLORS };
};

export const getSiteLogoAccentIconColor = (theme: Theme): string | undefined =>
    theme.palette.mode === 'light' ? LIGHT_LOGO_ICON_COLOR : undefined;

/** Highlight word in logo title ("Update", "King", etc.) — Adobe blue in light mode. */
export const getSiteLogoAccentTextColor = (theme: Theme, darkFallback: string): string =>
    theme.palette.mode === 'light' ? LIGHT_LOGO_ICON_COLOR : darkFallback;

/** Border around the three channel icons — Adobe blue in light mode. */
export const getSiteLogoChannelBorderColor = (theme: Theme): string =>
    theme.palette.mode === 'light' ? LIGHT_LOGO_ICON_COLOR : theme.palette.primary.main;
